import {ProgressiveLightMap} from "../../../../Utils/ThreeJS/ProgressiveLightMap.js";
import {Hud, OrthographicCamera, PerspectiveCamera} from "@react-three/drei";
import React, {useMemo, useState} from "react";
import * as THREE from "three";
import {GetSingleColorTexture} from "../../../../Utils/ThreeJS/TextureUtils.js";
import {useFrame} from "@react-three/fiber";
import {store} from "../../../../Store/index.js";
import {observer_mgl_r3} from "../../../../Utils/ThreeJS/General.js";
import {LHQInstance} from "../LHQ/Scene.js";

// choose precise+arbitrary values here, to keep them unique (it's how the near/far getters in LHQ.tsx reject copying these near/far values onto the non-hud cameras)
const LHQOverlay_nearClipPlane = 0.00123;
const LHQOverlay_farClipPlane = 10.00123;
export const hudCameras_nearClipValues = [LHQOverlay_nearClipPlane];
export const hudCameras_farClipValues = [LHQOverlay_farClipPlane];

export const LHQOverlay = observer_mgl_r3((props: {lhq: LHQInstance})=>{
	const lightmapState_global = store.main.testing.vrLightmap;

	// Scene component is set to never re-render; so we have to detect when its lightmap gets swapped out (so we can re-render this component, and send the new lightmap to LightmapDebugTexture)
	const [lightmap, setLightmap] = useState<ProgressiveLightMap|n>(null);
	useFrame(()=>{
		const latestLightmap = props.lhq.lightmap;
		if (latestLightmap != lightmap) {
			setLightmap(latestLightmap);
		}
	});

	if (!lightmapState_global.debugLightmap) return null;
	return (
		/*<>
			<Hud>
				<PerspectiveCamera makeDefault position={[0, 0, 10]} far={1000}/>
			</Hud>
			<Hud renderPriority={2}>
				<OrthographicCamera makeDefault position={[0, 0, 1]} left={0} right={1} bottom={0} top={1} near={0.1} far={10}/>
				<LightmapDebugTexture lightmap={lightmap} color="rgb(0,255,0)"/>
			</Hud>
		</>*/
		<Hud>
			<OrthographicCamera makeDefault position={[0, 0, 1]} left={0} right={1} bottom={0} top={1} near={LHQOverlay_nearClipPlane} far={LHQOverlay_farClipPlane}/>
			<LightmapDebugTexture lightmap={lightmap} color="rgb(0,255,0)"/>
		</Hud>
	);
});

const textureNames = [
	"progressiveLightMap1",
	"progressiveLightMap2",
	"stochasticDepthColorBuffer",
	"progressiveBounceMap1",
	"progressiveBounceMap2",
	"compositeLightMap1",
	"compositeLightMap2",
] as Array<keyof ProgressiveLightMap>;
const LightmapDebugTexture = (props: {lightmap: ProgressiveLightMap|n, color?: string|n})=>{
	const {lightmap, color} = props;
	const [textureName, setTextureName] = useState(textureNames[1]);
	if (lightmap == null) return null;

	//const size = new Vec2(lightmap.compositeLightMap1.texture.image.width, lightmap.compositeLightMap1.texture.image.height);
	const lightmapTexture = (lightmap[textureName] as THREE.WebGLRenderTarget).texture;
	//const lightmapTexture = lightmap.compositeLightMap1.texture;
	//const lightmapTexture = GetSingleColorTexture("rgb(255,255,255)");

	return (
		<mesh name="lightmapDebugMesh" renderOrder={1000} position={[.5, .9, 0]} onClick={()=>{
			const index = textureNames.indexOf(textureName);
			const nextIndex = (index + 1) % textureNames.length;
			setTextureName(textureNames[nextIndex]);
			console.log("Showing:", textureNames[nextIndex]);
		}}>
			<planeGeometry args={[.2, .2]} ref={c=>{
				if (c == null) return;
				// have uv1 be the same as uv0; this way we see the texture contents, regardless of if the texture we're showing is set to use uv0 or uv1
				c.setAttribute("uv1", c.attributes.uv.clone());
			}}/>
			<meshBasicMaterial /*color={new THREE.Color(color ?? `rgb(255,0,0)`)}*/ map={lightmapTexture} side={THREE.DoubleSide} /*transparent={true}*/ depthTest={false}/>
		</mesh>
	);
};